// extracted by mini-css-extract-plugin
module.exports = {"otherWordContainer":"CEFRBadge_otherWordContainer__3LsQA"};